export const Disability = [
    { label: "None", value: "none" },
    { label: "Physical disability", value: "physical disability" }
]